<template>
    <div>
        <ul class="nav nav-tabs px-3 tabs mb-3 mt-2" role="tablist">
            <li class="nav-item">
                <button
                    class="nav-link"
                    :class="{ active: currentTab === 'tab1', 'text-muted': currentTab !== 'tab1' }"
                    @click="currentTab = 'tab1'"
                >
                    Données
                </button>
            </li>
            <li class="nav-item">
                <button
                    class="nav-link"
                    :class="{ active: currentTab === 'tab2', 'text-muted': currentTab !== 'tab2' }"
                    @click="currentTab = 'tab2'"
                >
                    Filtres
                </button>
            </li>

            <!-- <li class="nav-item">
                <button
                    class="nav-link"
                    :class="{ active: currentTab === 'tab4', 'text-muted': currentTab !== 'tab4' }"
                    @click="currentTab = 'tab4'"
                >
                    SMS
                </button>
            </li>
            <li class="nav-item">
                <button
                    class="nav-link"
                    :class="{ active: currentTab === 'tab6', 'text-muted': currentTab !== 'tab6' }"
                    @click="currentTab = 'tab6'"
                >
                    Liste SMS
                </button>
            </li> -->

            <!-- 
            <li class="nav-item">
                <button
                    class="nav-link"
                    :class="{ active: currentTab === 'tab7', 'text-muted': currentTab !== 'tab7' }"
                    @click="currentTab = 'tab7'"
                >
                    tab7
                </button>
            </li> -->

            <!-- <li class="nav-item">
                <button
                    class="nav-link"
                    :class="{ active: currentTab === 'tab3', 'text-muted': currentTab !== 'tab3' }"
                    @click="currentTab = 'tab3'"
                >
                    Email
                </button>
            </li>
            <li class="nav-item">
                <button
                    class="nav-link"
                    :class="{ active: currentTab === 'tab5', 'text-muted': currentTab !== 'tab5' }"
                    @click="currentTab = 'tab5'"
                >
                    Liste des emails
                </button>
            </li> -->
        </ul>
        <div class="tab-content">
            <component :is="currentTab"></component>
        </div>
    </div>
</template>

<script>
import CustomerDatatable from '../CustomerDatatable.vue'
import CustomerFilters from '../CustomerFilters.vue'
// import EmailTemplate from '../EmailTemplate.vue'
import CustomerSms from '../CustomerSms.vue'
// import EmailList from '../EmailList.vue'
import SmsList from '../SmsList.vue'
import Exmp from '../Exmp.vue'

export default {
    name: 'BoCustomerIndex',
    components: {
        tab1: CustomerDatatable,
        tab2: CustomerFilters,
        // tab3: EmailTemplate,
        tab4: CustomerSms,
        // tab5: EmailList,
        tab6: SmsList,
        tab7: Exmp,
    },
    data: () => ({
        mode: 'light',
        currentTab: 'tab1',
    }),
    methods: {},
}
</script>

<style>
.text-muted {
    color: #94a3b8 !important;
}
</style>
